import { render, staticRenderFns } from "./QuestionModalCardClaimGain.vue?vue&type=template&id=79728c89&scoped=true&"
import script from "./QuestionModalCardClaimGain.vue?vue&type=script&lang=js&"
export * from "./QuestionModalCardClaimGain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79728c89",
  null
  
)

export default component.exports